import { ProductionFulfillmentApi, useAPIQuery } from "melco-shared-logic";

export const useMissingFontValidation = (
  mappingId: string | undefined,
  designId: string | undefined,
  letteringElementId: string | undefined
) => {
  const query = useAPIQuery(
    ProductionFulfillmentApi,
    [mappingId, designId, letteringElementId],
    async (api) => {
      if (mappingId == null || designId == null || letteringElementId == null) {
        return;
      }

      return api.productionFulfillmentMappingsValidateAlphabet({
        mappingId,
        designId,
        letteringElementId,
      });
    }
  );

  const isMissingFont = query.data?.result === false;

  return [isMissingFont, query] as const;
};
